import { ForwardedRef, useEffect, useRef } from 'react';

// https://stackoverflow.com/questions/73015696/whats-the-difference-between-reacts-forwardedref-and-refobject/73046577#73046577
// The idea behind this hook is that the component can create its own ref,
// which it can use regardless of whether the parent forwarded a ref.
// The hook helps ensure that any forwarded ref's .current property is kept in sync with the inner one's.
export const useForwardedRef = <T>(ref: ForwardedRef<T>) => {
  const innerRef = useRef<T>(null);

  useEffect(() => {
    if (!ref) {
      return;
    }

    if (typeof ref === 'function') {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  });

  return innerRef;
};
